<template>
  <div>
    <div :class="{ mobileBody: isMobile, pcBody: !isMobile, body: true }">
      <van-image
        :class="{
          mobileContent: isMobile,
          pc: !isMobile,
          logo: true,
          Flex: loagImageFlex,
          FlexPc: !isMobile && loagImageFlex,
          FlexPcMobile: isMobile && loagImageFlex
        }"
        :src="
          loagImageFlex
            ? require('../../../../public/image/01/8.png')
            : require('../../../../public/image/01/9.png')
        "
      ></van-image>
      <van-image
        class="banner"
        :src="require('../../../../public/image/01/1.png')"
      ></van-image>
      <div :class="{ mobile: isMobile, pc1: !isMobile, buttonlist: true }">
        <div>
          <a href="javascript:;" @click="clickLeftImage"></a>
        </div>
        <div>
          <!-- DC -->
          <a
            href="https://discord.gg/wzMReVas33"
            @click="getButton('置頂-DC按鈕')"
            target="_black"
          ></a>
        </div>
        <div>
          <!-- FB -->
          <a
            href="https://www.facebook.com/CrossGate.TW/"
            @click="getButton('置頂-FB按鈕')"
            target="_black"
          ></a>
        </div>
      </div>
      <div class="footer">
        <div class="footerWarp">
          <van-image
            @click="
              $emit('scrollIntoView', '#Activity02')
              getButton('立即預約')
            "
            class="button1"
            :src="require('../../../../public/image/01/4.png')"
          ></van-image>

          <div class="buttonwarp">
            <a
              :href="
                isMobile
                  ? 'https://crossgatetw.onelink.me/0CmU/mobile'
                  : 'https://crossgatetw.onelink.me/0CmU/ios'
              "
              @click="Subscribe()"
              target="_black"
            >
              <van-image
                class="button"
                :src="require('../../../../public/image/01/5.png')"
              ></van-image>
            </a>
            <a
              :href="
                isMobile
                  ? 'https://crossgatetw.onelink.me/0CmU/mobile'
                  : 'https://crossgatetw.onelink.me/0CmU/google'
              "
              @click="AddPaymentInfo()"
              target="_black"
            >
              <van-image
                class="button"
                :src="require('../../../../public/image/01/2.png')"
              ></van-image>
            </a>
          </div>
        </div>
      </div>
    </div>
    <RewardListDialog
      v-if="list"
      :list="list"
      :titleImage="require('../../../../public/image/12/1/1.png')"
      :backgroundImage="require('../../../../public/image/12/4/4.png')"
      :removeImage="require('../../../../public/image/12/6/3.png')"
      :visible.sync="showRewardList"
      @showPhoneHandel="$emit('showPhoneHandel')"
      @changeVisible="showRewardList = !showRewardList"
    />
  </div>
</template>

<script>
import isMobile from '../../../../utils/isMobile.js'
import getData from '../../../../utils/request/request'
import RewardListDialog from '../components/rewardListDialog/index.vue'
import getButton from '../../../../utils/getButton'

import { Toast } from 'vant'
import { mapGetters } from 'vuex'

export default {
  components: {
    RewardListDialog
  },
  props: {
    loagImageFlex: Boolean
  },
  data() {
    return {
      isMobile: isMobile(),
      showRewardList: false,
      list: null
    }
  },
  created() {
    console.log(this.isMobile)
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  methods: {
    getButton(val) {
      getButton(val)
    },
    Subscribe() {
      getButton('蘋果商店預約')
      fbq('track', 'Subscribe')
      ttq.track('CompleteRegistration')
    },
    AddPaymentInfo() {
      getButton('谷歌商店預約')
      fbq('track', 'AddPaymentInfo')
      ttq.track('AddPaymentInfo')
    },
    async clickLeftImage() {
      getButton('置頂-查詢獎勵')
      let Api = {
        url: '/api/get_giftlist',
        type: 'post'
      }
      let form = {
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.list = res.list
        this.showRewardList = true
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    goRouter() {
      this.$router.push({ name: 'crossgate.prereg02' })
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.buttonlist {
  position: fixed;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1000;
  div {
    padding: 0.1rem 0rem;
  }
  div a {
    display: block;
  }
  div:nth-child(1) a {
    width: 3rem;
    height: 3rem;
    background: url(../../../../public/image/01/3.png) no-repeat;
    background-size: 100% 100%;
  }
  div:nth-child(2) a {
    width: 3rem;
    height: 3rem;
    background: url(../../../../public/image/01/6.png) no-repeat;
    background-size: 100% 100%;
  }
  div:nth-child(3) a {
    width: 3rem;
    height: 3rem;
    background: url(../../../../public/image/01/7.png) no-repeat;
    background-size: 100% 100%;
  }
  //   .icon {
  //     width: 3rem;
  //     height: 3rem;
  //     padding: 0.1rem 0rem;
  //     /deep/ .van-image {
  //     }
  //   }
}

.footer {
  position: absolute;
  bottom: 0rem;
  width: 100%;
  padding: 1rem 4rem;
  box-sizing: border-box;
  .button1 {
    animation: heartbeat 1s ease infinite;
  }
  .buttonwarp {
    display: flex;
    justify-content: center;
    .button {
      padding: 0.1rem;
    }
  }
}
.logo {
  width: 70%;
  display: block;
  // position: absolute;
  // left: 50%;
  // top: 2%;
  // transform: translateX(-50%);
  margin: 0 auto;
  padding-top: 2%;
}

.pc1 {
  right: calc(((100vw - (8 / 15 * 100vh)) / 2) + 1rem);
}

.mobileContent {
  top: 0;
  z-index: 1000;
}
.FlexPc {
  position: fixed;
  z-index: 1000;
  width: 120px;
  left: calc(((100vw - (8 / 15 * 100vh)) / 2) + 1rem);
  transform: translateX(0%);
}
.FlexPcMobile {
  position: fixed;
  z-index: 1000;
  width: 30%;
  transform: translateX(0%);
}
.banner {
  width: 80%;
  // top: 5rem;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  margin: 0 auto;
  display: block;
}
.body {
  position: relative;
  width: 100%;
  // height: 600px;
  // height: calc(100vw / 375 * 628);
  background: url(../../../../public/image/10/01.jpg) no-repeat;
  background-size: 100% 100%;
}
.pcBody {
  height: calc((8 / 15 * 100vh) / 375 * 628);
}
.mobileBody {
  height: calc(100vw / 375 * 628);
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity01/index.vue